module.exports = __webpack_public_path__ + "static/schmincke-f3451b8f694246f2b4fa513accda82ba.png";